<template>
    <v-container fluid style = 'padding:0;'>

      <v-snackbar v-model="showErrorAlert" color="error" dismissible location="top">
        {{ errorMessage }}
      </v-snackbar>

      <div class = 'unsubscribe-wrapper'>

        <h1 v-if="isLoaded">Unsubscribe</h1>
        
        <div v-if="isLoaded&&booking&&unsubscribeComplete" class = 'content-item'>

          <div class = 'explain-icon'>
            <v-icon>mdi-emoticon-happy-outline</v-icon>
          </div>
          <div class = 'explain-title'>
            Thank You!
          </div>
          <div class = 'explain-message'>
            We're sorry to see you go.  Your booking has been successfully cancelled.
          </div> 
          
          <div class = 'button-wrapper center'>
            &nbsp;
          </div>

        </div>            
        <div v-else-if="isLoaded&&booking&&!unsubscribeComplete" class = 'content-item'>

          <div class = 'section-descriptor'>
            <div>
              <v-icon>mdi-email-box</v-icon>
            </div>
            <div>
              <h2>Are you sure you want to unsubscribe?</h2>
            </div>
          </div>

          <div class = 'reason-wrapper'>
            <v-textarea
              v-model="unsubscribeReason"
              placeholder="Reason"
              rows="3"
              variant="outlined"
              clearable
            ></v-textarea>
          </div>
          
          <div class = 'button-wrapper center'>
            <v-btn @click="unsubscribe()" :disabled="updateUnderway" variant="tonal">Unsubscribe</v-btn>
          </div>

        </div>
        <div v-else-if="isLoaded&&!booking" class = 'content-item'>
          <div class = 'explain-icon'>
            <v-icon>mdi-emoticon-sad-outline</v-icon>
          </div>
          <div class = 'explain-title'>
            Oh no!
          </div>
          <div class = 'explain-message'>
            Unfortunately, we can't find that booking.
          </div>
          <div class = 'explain-message'>
            <p>Please <a href = 'mailto:info@healthcasa.com' target = '_new'>Email us</a> or <a href = 'sms:+16476915150' target = '_new'>Text us</a> if you require any further assistance.</p>
          </div> 

          <div class = 'button-wrapper center'>
            &nbsp;
          </div>

        </div>


      </div>

    </v-container>
  </template>
  
<script>
import axios from 'axios';
import api from '@/api.js';
import logo from '@/assets/logo.webp';

export default {
    name: 'BookingUnsubscribeView',
    components: { 
    },    
    data() {
        return {
            logo,
            isLoaded: false,
            code: null,
            updateUnderway: false,

            booking: null,
            unsubscribeComplete: false,
            unsubscribeError: '',
            unsubscribeReason: '',

            showErrorAlert: false,
            errorMessage: ''
        }
    },
    methods: {

      async load() {
        let headers = await api.getApiHeaders();
        try {
          let response = await axios.get(api.getApiUrl('u/booking-status/info/' + this.code), { headers });
          this.booking = response.data.booking;
        } catch (error) {
          console.error('Error:', error);
          if (error.response && error.response.data.detail) {
            this.errorMessage = error.response.data.detail;
          } else {
            this.errorMessage = 'Unable to get booking.';
          }
          this.showErrorAlert = true;
        }          
      },
      async loadRefresh() {
        await this.load();
        this.isLoaded = true;
      },
      async unsubscribe() {
        if(!this.unsubscribeReason) {
          this.showErrorAlert = true;
          this.errorMessage = 'Please provide a reason for unsubscribing to continue.';
          return;
        }

        this.unsubscribeError = '';
        try {
          this.updateUnderway = true;
          let headers = await api.getApiHeaders();
          await axios.put(api.getApiUrl('u/booking-status/unsubscribe/' + this.code), { reason: this.unsubscribeReason }, { headers });
          this.unsubscribeComplete = true;
        } catch (error) {
          console.error('Error:', error);
          if (error.response && error.response.data.detail) {
            this.unsubscribeError = error.response.data.detail;
          } else {
            this.unsubscribeError = 'Unable to unsubscribe booking.';
          }
        } finally {
          this.updateUnderway = false;
        }
      }

    },
    async mounted() {
        let split_by_slash = this.$route.path.split("/");
        this.code = split_by_slash[split_by_slash.length - 1];
        await this.loadRefresh();
    }

};
</script>
<style lang="scss">

$primaryDark: #32598C;
$primaryLight: #00B0DA;
$accent: #F25631;
$error: #FF4B55;
$errorHover: #CC3C44;
$button: #00B0DA;


DIV.unsubscribe-wrapper {
  > DIV.content-item {
    height:calc(100vh - 293px);
    display:flex;
    flex-direction:column;
    justify-content:space-between;

    @media (max-width: 1250px) {
      height:calc(100vh - 307px);
    }
  }
}


DIV.explain-icon {
  margin-top:20px;
  text-align:center;
  font-size: 45px;
  color: $accent;
}

DIV.explain-title {
  text-align:center;
  font-size: 18px;
  font-weight:700;
  color: $primaryDark;
  margin-top:20px;
}

DIV.explain-message {
  font-size: 15px;
  font-weight:500;
  color: $primaryDark;
  margin-top:20px;
  margin-left:auto;
  margin-right:auto;
  width:250px;
  text-align:center;

  A {
    color: $accent;
  }
}

DIV.reason-wrapper {
  margin-top:20px;
}

</style>
